import React, {Component} from "react";
import styles from './css/FJTransitionPreview.module.less'

class FJTransitionPreview extends Component{

	constructor(props) {
		super(props);
		this.defaultProgress = props.defaultProgress || 0.25;
		this.state = {
			progress: this.defaultProgress,
			isHover: false,
		};
	}

	/**
	 * 传递进度到父组件
	 */
	_sendProgress = (progress) => {
		if (this.props.handleProgress) {
			this.props.handleProgress(progress);
		}
	};

	/**
	 * 鼠标hover事件
	 */
  mouseEnter = () => {
    this.setState({isHover: true});
	};

	/**
	 * 鼠标leave事件
	 */
	mouseLeave = () => {
		this.setState({isHover: false, progress: this.defaultProgress}, () => {
      this._sendProgress(this.defaultProgress);
    });
	};
	/**
	 * 鼠标移动事件
	 * @param e
	 */
	mouseMove = (e) => {
		let x = e.nativeEvent.offsetX;
		let clientWidth = e.target.clientWidth;
		let progress = x / clientWidth;
		this.setState({progress}, () => {
      this._sendProgress(progress);
    });
	}

	render() {

		let {
			children,
		} = this.props

		let {progress, isHover} =  this.state;
		let left = progress * 100 + '%';

		return (
			<div className={styles.c_preview_controller}
					 onMouseEnter={this.mouseEnter}
					 onMouseLeave={this.mouseLeave}
					 onMouseMove={this.mouseMove}>
				{children}
				<i className={styles.c_progress_line} style={{
					display: isHover ? '' : 'none',
					left: left
				}}/>
			</div>
		)
	}
}

export default FJTransitionPreview;